export default __webpack_public_path__ + "fl-studio.4cf3a1af.png";